import { catchError, throwError } from "rxjs";
import { redirectConfig } from "./api.config";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getApiErrorText(err) {
    var _a, _b, _c;
    return `${(_a = err === null || err === void 0 ? void 0 : err.message) !== null && _a !== void 0 ? _a : 'unknown error'} ${(_c = (_b = err === null || err === void 0 ? void 0 : err.request) === null || _b === void 0 ? void 0 : _b.url) !== null && _c !== void 0 ? _c : 'unknown url'}`;
}
export function catchApiError() {
    return catchError((err) => {
        var _a;
        const status = err.status;
        const redirect = (_a = redirectConfig.redirectByStatus[status]) !== null && _a !== void 0 ? _a : redirectConfig.defaultRedirect;
        window.location.href = redirect;
        return throwError(() => new Error(getApiErrorText(err)));
    });
}
// This is type util is the equivalent of a strict partial
// type Exactly<T, U extends T> = { [K in keyof U]: K extends keyof T ? T[K] : never };
// type IsExactly<T, U extends T> = U extends Exactly<T, U> ? true : false;
// const testGood = { g: 1 }
// type TestGood = IsExactly<Class2, typeof testGood>; // true
